<template>
    <span
    color="green"
    @click="goBack"
    class="pointer green-txt caption text-uppercase font-weight-medium">
      <v-icon
        dense
        color="green"
        class="white--text"
      >
        mdi-chevron-left
      </v-icon>
      {{ btnText }}
    </span>
</template>

<script>
export default {
  name: 'BackButton',
  props: ['navigatedFrom'],
  data () {
    return {
      btnText: 'BACK'
    }
  },
  methods: {
    goBack () {
      if (history.length > 2) {
        this.$router.back()
      } else {
        if (this.navigatedFrom !== '') {
          this.$router.push({ name: this.navigatedFrom })
        }
      }
    }
  }
}
</script>
